import { Box, Button, Typography } from "@mui/material";
import { SearchBar } from "components/SearchPatients/SearchBar";
import { CommonTexts, Dashboard } from "locale/es";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPatient } from "redux/reducers/selectedPatientReducer";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CustomDialog from "components/Dialogs/MasterDialog";
import ExportForm from "pages/Dashboard/ExportHealthData/ExportDialog";

function IndexWithSearchBar() {
  const [showExportModal, setShowExportModal] = useState(false);

  const allPatients = useSelector(({ allPatients }) => allPatients.data);
  const selectedPatient = useSelector(({ patient }) => patient);

  const dispatch = useDispatch();

  const handleChangeSelectedPatient = (event, value) => {
    if (value) {
      dispatch(selectPatient(value));
    }
  };

  const findSelectedPatient = () => allPatients.find((patient) => patient.id === selectedPatient.id);

  const handleShowExportModal = () => {
    setShowExportModal(!showExportModal);
  };

  return (
    <>
      <Box>
        {!selectedPatient.id && (
          <Box sx={{ mb: 2 }}>
            <Typography variant='subtitle_bold'>
              {CommonTexts.SELECT_PATIENT}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
          }}
        >
          <Box
            sx={{ flexGrow: 2, flexShrink: 1, flexBasis: "50%", minWidth: 300 }}
          >
            <SearchBar
              allDataSearch={allPatients}
              selectedData={selectedPatient}
              isPatientComponent={true}
              handleChange={handleChangeSelectedPatient}
              findSelected={findSelectedPatient() || ""}
              placeholder={CommonTexts.SEARCH_PATIENT}
            />
          </Box>
        </Box>
      </Box>
    </>

  );
}

export default IndexWithSearchBar;
